import { Dispatch, useEffect } from 'react'

import { NewSigninAction, SigninBanner } from '../types'

export const TRANSIENT_BANNER_MS = 5000

/** Banners that only confirm something happened. Everything else waits to be acted on. */
const TRANSIENT_KINDS: SigninBanner['kind'][] = ['codeResent']

export interface IUseTransientBannerParams {
  banner: SigninBanner
  localDispatch: Dispatch<NewSigninAction>
}

/**
 * Clears a confirmation once it has been read. A message with nothing to act on would
 * otherwise sit above the form until the next thing the visitor does replaces it.
 */
export const useTransientBanner = ({ banner, localDispatch }: IUseTransientBannerParams): void => {
  useEffect(() => {
    if (!TRANSIENT_KINDS.includes(banner.kind)) {
      return
    }

    const timer = window.setTimeout(() => localDispatch({ type: 'bannerCleared' }), TRANSIENT_BANNER_MS)

    return () => window.clearTimeout(timer)
  }, [banner])
}
